import { Button, EmptyState } from '@greensm/ui';
import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State { error: Error | null }

/** Lỗi render không bắt được ở nơi khác ⇒ màn hình thân thiện, không trắng trang. */
export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    // Điểm nối với dịch vụ giám sát (Sentry…) khi có.
    console.error('[AppErrorBoundary]', error, info.componentStack);
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ padding: 24 }}>
        <EmptyState
          icon="warn"
          title="Có lỗi không mong muốn"
          description="Ứng dụng gặp sự cố. Dữ liệu của bạn vẫn an toàn."
          action={<Button onClick={() => { this.setState({ error: null }); location.assign('/'); }}>Về trang chủ</Button>}
        />
      </div>
    );
  }
}
